const tokens = {
  primary: '#3b3a2e',
  primarySoft: '#f0ece4',
  brandDark: '#2c2a20',
  brandDarkAlt: '#3b3a2e',
  accent: '#8cc63f',
  warmBrown: '#5b4a3a',
  text: '#2c2a20',
  muted: '#7a7265',
  bgApp: '#eae6dc',
  surface: '#f5f2eb',
  surfaceAlt: '#edeae2',
  borderSoft: '#d4cdbf',
  success: '#8cc63f',
  warning: '#f5a524',
  danger: '#e5484d',
  info: '#2f80ed',
  shadowSoft: '0 24px 60px rgba(16, 26, 18, 0.12)',
  shadowCard: '0 12px 30px rgba(16, 26, 18, 0.08)',
  radiusLg: '24px',
  radiusMd: '16px',
  radiusSm: '12px',
  radiusPill: '999px',
}

const boxShadow = tokens.shadowSoft
const primary = tokens.primary
const bgPrimaryLight = 'rgba(59, 58, 46, 0.10)'
const primaryGradient = tokens.primary
const widthFull = '300px'
const widthResize = '92px'
const widthWithPadding = '260px'
const widthResizeWithPadding = '56px'
const heightHeader = '76px'
const heightFooter = '46px'

export {
  tokens,
  boxShadow,
  primary,
  bgPrimaryLight,
  primaryGradient,
  widthFull,
  widthResize,
  heightHeader,
  heightFooter,
  widthWithPadding,
  widthResizeWithPadding,
}